import type { Hotel } from '@/interfaces';
import displayValues from '@/resources/displayValues.json';

const facilitiesMap = displayValues.amenities.facilities as Record<string, string>;
const activitiesMap = displayValues.amenities.activities as Record<string, string>;

export const getAmenitiesList = (hotel: Hotel): string[] => {
    const translatedFacilities = (hotel.facilities ?? []).map((key) => facilitiesMap[key]).filter(Boolean);
    const translatedActivities = (hotel.activities ?? []).map((key) => activitiesMap[key]).filter(Boolean);

    return [...translatedFacilities, ...translatedActivities];
};

export const getAmenitiesText = (hotel: Hotel): string => getAmenitiesList(hotel).filter(Boolean).join(' • ');
